define('presentation/signup/viewModels/signupFooterViewModel',[
        'businessServices/router/router',
        'businessServices/signup/signupSessionStore',
        'common/promises/promiseFactory',
        'common/storage/workSessionIdStorage',
        'presentation/signup/common/signupPageIndicatorWidget',
        'settings/navigationConfiguration',
        'presentation/signup/common/signupNavigationManager',
        'businessServices/browserSupport/browserType',
        'common/url/urlFormatter',
        'constants/signupSessionFlowConstants'
    ],
    function() {
        return function() {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            let _signupSessionStore = null;
            let _signupNavigationManager = null;

            const _browserType = require('businessServices/browserSupport/browserType');
            const _i18n = require('i18next');
            const _navigationConfiguration = require('settings/navigationConfiguration');
            const _router = require('businessServices/router/router');
            const _signupSessionFlowConstants = require('constants/signupSessionFlowConstants');
            const _urlFormatter = require('common/url/urlFormatter');
            const _workSessionIdStorage = require('common/storage/workSessionIdStorage');

            const AppEntryWidthBreakpoint = 1100;
            const AppEntryHeightBreakpoint = 768;

            let _disposables = [];

            let _onAgentBypassClicked = () => _promiseFactory.deferIndefinitely(promise => promise.resolve(false));
            let _onForwardArrowClicked = () => _promiseFactory.deferIndefinitely(promise => promise.resolve(false));

            self.isSignupForCustomer = ko.observable(false);
            self.isNavigateToPreviousPageVisible = ko.observable(true);
            self.nextPageButtonText = ko.observable(_i18n.t('signupFooter:next'));
            self.isNavigateToNextPageVisible = ko.observable(true);
            self.isNavigateToNextPageActive = ko.observable(false);
            self.isNextPageArrowVisible = ko.observable(true);
            self.isAgentBypassVisible = ko.observable(false);
            self.onLogInClicked = () => {
                _router.navigate(_navigationConfiguration.loginPageUrl);
            };
            self.agentBypassButtonText = _i18n.t('signupFooter:agentBypass');
            self.agreeToTerms = _i18n.t("signupFooter:agreeToTerms");
            self.agreeToTermsUrl = _urlFormatter.buildFrontendUrl("/terms");
            self.isFooterVisible = ko.observable(true);
            self.isScrollActive = ko.observable(false);
            self.flow = ko.observable();
            self.flowBFooterText = ko.observable('');
            self.routeId = ko.observable();

            self.isMobile = ko.pureComputed(() => _browserType.windowWidth() <= AppEntryWidthBreakpoint || _browserType.windowHeight() <= AppEntryHeightBreakpoint);
            self.isFlowBFooterTextVisible = ko.computed(() => self.flow() === _signupSessionFlowConstants.flowB && !self.isMobile());

            self.navigateToFlowD = () => {
                _signupNavigationManager.navigateToRoute(_navigationConfiguration.routesById.signupPhoneNumberType.routeId, _signupSessionFlowConstants.flowD);
            };

            self.navigateToPreviousPage = () => {
                _signupNavigationManager.previousPage();
            };

            let _navigationClicked = true;
            self.navigateToNextPage = () => {
                return _promiseFactory.defer((deferredObject) => {
                    if (_navigationClicked) {
                        deferredObject.resolve();
                    } else {
                        _navigationClicked = true;
                        const minimumSpinTime = 1000 + new Date().getTime();
                        _onForwardArrowClicked()
                            .fail(deferredObject.reject)
                            .done(shouldNavigate => {
                                if (shouldNavigate) {
                                    setTimeout(() => {
                                        _onForwardArrowClicked = () => _promiseFactory.deferIndefinitely(promise => promise.resolve(false));
                                        _signupNavigationManager.nextPage();
                                        deferredObject.resolve();
                                    }, minimumSpinTime - new Date().getTime());
                                } else {
                                    _navigationClicked = false;
                                    deferredObject.resolve();
                                }
                            });
                    }
                });
            };


            let _agentBypassClicked = false;
            self.onAgentBypass = () => {
                return _promiseFactory.defer((deferredObject) => {
                    if (_agentBypassClicked) {
                        deferredObject.resolve();
                    } else {
                        _agentBypassClicked = true;
                        const minimumSpinTime = 1000 + new Date().getTime();
                        _onAgentBypassClicked()
                            .fail(deferredObject.reject)
                            .done((shouldNavigate) => {
                                if (shouldNavigate) {
                                    setTimeout(() => {
                                        _onAgentBypassClicked = () => _promiseFactory.deferIndefinitely(promise => promise.resolve(false));
                                        _signupNavigationManager.nextPage();
                                        deferredObject.resolve();
                                    }, minimumSpinTime - new Date().getTime());
                                } else {
                                    _agentBypassClicked = false;
                                    deferredObject.resolve();
                                }
                            });
                    }
                });
            };

            self.detached = function() {
                _signupNavigationManager.detached();
                _disposables.forEach(subscription => subscription.dispose());
                _disposables = [];
            };

            self.activate = function(data) {
                const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
                _signupSessionStore = new SignupSessionStoreConstructor();
                _signupSessionStore.init();

                const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
                _signupNavigationManager = new SignupNavigationManagerConstructor();
                _signupNavigationManager.init();

                self.flow(_signupNavigationManager.getFlowId());
                self.routeId(_signupNavigationManager.getRouteId());

                const setSelfValues = (element) => {
                    const dataElement = data[element];
                    if (dataElement !== undefined) {
                        const selfElement = self[element];
                        if (ko.isObservable(dataElement)) {
                            selfElement(dataElement());
                            _disposables.push(dataElement.subscribe(selfElement));
                        } else {
                            selfElement(dataElement);
                        }
                    }
                };
                setSelfValues('isFooterVisible');
                setSelfValues('isNavigateToNextPageActive');
                setSelfValues('isNextPageArrowVisible');
                setSelfValues('nextPageButtonText');

                if (data.isNavigateToPreviousPageVisible) {
                    self.isNavigateToPreviousPageVisible = data.isNavigateToPreviousPageVisible;
                } else {
                    self.isNavigateToPreviousPageVisible(_signupNavigationManager.isPreviousPageValid());
                }

                if (data.isNavigateToNextPageVisible !== undefined) {
                    setSelfValues('isNavigateToNextPageVisible');
                } else {
                    self.isNavigateToNextPageVisible(_signupNavigationManager.isNextPageValid());
                }

                if (data.isAgentBypassVisible !== undefined) {
                    setSelfValues('isAgentBypassVisible');
                }

                // page resolves whether to advance; footer handles the navigation.
                if (data.onForwardArrowClicked) {
                    _onForwardArrowClicked = data.onForwardArrowClicked;
                }

                // page resolves whether to advance and handles navigation.
                // i.e., navigate to an out-of-flow page
                if (data.onNextPageClicked) {
                    self.navigateToNextPage = data.onNextPageClicked;
                }

                if (data.onAgentBypassClicked) {
                    _onAgentBypassClicked = data.onAgentBypassClicked;
                }

                if (data.onBackArrowClicked) {
                    self.navigateToPreviousPage = data.onBackArrowClicked;
                }

                if (self.flow() === _signupSessionFlowConstants.flowB) {
                    switch (self.routeId()) {
                        case _navigationConfiguration.routesById.signupPhoneNumberLocal.routeId:
                            self.flowBFooterText('flowBFooterLocalText');
                            break;
                        case _navigationConfiguration.routesById.signupPhoneNumberTollfree.routeId:
                            self.flowBFooterText('flowBFooterTollFreeText');
                            break;
                        case _navigationConfiguration.routesById.signupPhoneNumberPort.routeId:
                            self.flowBFooterText('flowBFooterPortText');
                            break;
                        default:
                            break;
                    }
                }
                return _initialize();
            };

            const _initialize = () => {
                _navigationClicked = false;

                const workSessionId = _workSessionIdStorage.getWorkSessionId();
                self.isSignupForCustomer(workSessionId !== null && workSessionId !== undefined);

                _promiseFactory.wait();
            };
        };
    });

